import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Button } from "primereact/button";

const AdminProfile = () => {
  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  //   navigate
  const navigate = useNavigate();

  return (
    <>
      <AppBreadcrumb
        pageName="Profile"
        currentMenu="Admin"
        pageTitle={
          <>
            <div className="gotopage-button-header">
              <Button
                icon="pi pi-arrow-left"
                className="mr-2 common-p-gotopage-button"
                onClick={() => navigate("/admin-dashboard")}
              />
              <span className="span-text">Profile</span>
            </div>
          </>
        }
      />
      <Card className="p-0 bg-white" style={{ height: "calc(100% - 52px)" }}>
        <div className="grid">
          {/* name */}
          <div className="flex mb-3 col-12">
            <div className="">
              <label className="font-bold text-gray-700">Name :</label>
              <div className="flex gap-2 align-items-center">
                <h2 className="mt-1 mb-1 text-xl font-semibold text-gray-900">
                  {userData?.first_name ?? ""} {userData?.last_name ?? ""}
                </h2>
              </div>
            </div>
          </div>
          {/* other details */}
          <div className="col-12 md:col-12">
            <div className="grid p-fluid">
              {!window.cn(userData?.email) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Email:</label>
                  <div className="text-gray-900">{userData?.email || "-"}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default AdminProfile;
